import React from "react";
import Navigation from "../../Shared/Navigation/Navigation";
import AppointmentBanner from "../AppointmentBanner/AppointmentBanner";
import Banner from "../Banner/Banner";
import Doctors from "../Doctors/Doctors";
import Services from "../Services/Services";

const Home = () => {
	return (
		<div>
			<Navigation></Navigation>
			<Banner></Banner>
			<Services></Services>
			<AppointmentBanner></AppointmentBanner>
			<Doctors></Doctors>
		</div>
	);
};

export default Home;
